import { memo, useCallback } from 'react';

import { ConfirmDialog } from '../ConfirmDialog/ConfirmDialog';

interface RemoveOrderModalProps {
    isShowDeleteOrder: boolean;
    isLoadingDeleteOrder: boolean;
    title: string;
    text: string;
    deleteButtonText: string;
    onCloseDeleteOrder: () => void;
    onSubmitDeleteOrder: () => void;
}

export default memo(
    ({
        isShowDeleteOrder,
        title,
        text,
        onCloseDeleteOrder,
        onSubmitDeleteOrder,
        isLoadingDeleteOrder,
        deleteButtonText,
    }: RemoveOrderModalProps) => {
        const cancelOrderModal = useCallback(() => {
            if (!isLoadingDeleteOrder) {
                onCloseDeleteOrder();
            }
        }, [isLoadingDeleteOrder, onCloseDeleteOrder]);

        const submitOrderModal = useCallback(() => {
            if (!isLoadingDeleteOrder) {
                onSubmitDeleteOrder();
            }
        }, [isLoadingDeleteOrder, onSubmitDeleteOrder]);

        return (
            <ConfirmDialog
                open={isShowDeleteOrder}
                onClose={cancelOrderModal}
                title={title}
                text={<span dangerouslySetInnerHTML={{ __html: text }} />}
                confirmLabel={deleteButtonText}
                onConfirm={submitOrderModal}
                isLoading={isLoadingDeleteOrder}
                confirmColor="error"
                testId="modal-order-delete"
                confirmButtonTestClass="btn-order-delete"
            />
        );
    },
);
